"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopArea = void 0;
var _auth = require("@ori/auth");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _navigation = require("../../context/navigation");
var _BurgerMenu = require("../BurgerMenu");
var _JoinMenu = require("../Join/JoinMenu");
var _LeftActionsSection = require("../LeftActionsSection");
var _RightActionsSection = require("../RightActionsSection");
var _SearchInput = require("../SearchInput");
var _TopAreaBanner = require("../TopAreaBanner");
var _TopAreaNavigation = require("../TopAreaNavigation");
var _TopAreaNavigationMenu = require("../TopAreaNavigationMenu");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const TopArea = ({
  isTopBannerVisible,
  mobilePersonalMenuOutlet
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    isVisible: isSearchInputVisible
  } = (0, _navigation.useSearchInput)();
  const {
    isAnonymousUser
  } = (0, _auth.useToken)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    isSearchInputVisible: isSearchInputVisible,
    isTopBannerVisible: isTopBannerVisible,
    "data-testid": getTestId(_constants.TOP_AREA_ROOT),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LeftActionsSection.LeftActionsSection, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_RightActionsSection.RightActionsSection, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_BurgerMenu.BurgerMenu, {
      mobilePersonalMenuOutlet: mobilePersonalMenuOutlet
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TopAreaNavigationMenu.TopAreaNavigationMenu, {}), isAnonymousUser ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_JoinMenu.JoinMenu, {}) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_TopAreaBanner.TopAreaBanner, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TopAreaNavigation.TopAreaNavigation, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchInput.SearchInputButton, {
      showOnlyOn: "mobile"
    })]
  });
};
exports.TopArea = TopArea;
